import React from 'react';

const AVATAR_COLORS = [
  '#3B82F6',
  '#14B8A6',
  '#F59E0B',
  '#F97316',
  '#EC4899',
  '#8B5CF6',
  '#22C55E',
];

function hashName(name) {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = (h * 31 + name.charCodeAt(i)) >>> 0;
  }
  return h;
}

function getInitials(fullName) {
  if (!fullName) return '?';
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function EmployeeAvatar({ fullName, size = 28 }) {
  const name = fullName ?? '';
  const initials = getInitials(name);
  const color = AVATAR_COLORS[hashName(name) % AVATAR_COLORS.length];
  return (
    <span
      style={{ width: size, height: size, backgroundColor: color, fontSize: Math.round(size * 0.4) }}
      className="inline-flex items-center justify-center rounded-full text-white font-semibold shrink-0 select-none"
      aria-hidden="true"
    >
      {initials}
    </span>
  );
}

export default EmployeeAvatar;